/* Mareike Pisall Studio: Theme Skript (Navigation, Warenkorb, Produktseite). */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ── Navigation ─────────────────────────────────────── */
  var burger = document.getElementById('mp-nav-burger');
  var links = document.getElementById('mp-nav-links');
  function setNav(open) {
    if (!burger || !links) return;
    links.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
  }
  if (burger && links) {
    burger.addEventListener('click', function () { setNav(!links.classList.contains('is-open')); });
    document.addEventListener('click', function (e) {
      if (links.classList.contains('is-open') && !links.contains(e.target) && !burger.contains(e.target)) setNav(false);
    });
  }

  /* ── Warenkorb Seitenleiste ───────────────────────── */
  var lastFocus = null;
  function drawer() { return document.getElementById('mp-drawer'); }
  function shade() { return document.querySelector('[data-drawer-shade]'); }

  function openCart() {
    var d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    shade().hidden = false;
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-drawer-close]');
    (close || d).focus();
  }
  function closeCart() {
    var d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    shade().hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    if (count > 0) document.querySelectorAll('[data-cart-open][hidden]').forEach(function (b) { b.hidden = false; });
  }

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('mp-drawer-content');
    var current = document.getElementById('mp-drawer-content');
    if (next && current) {
      current.replaceWith(next);
      updateCount(parseInt(next.getAttribute('data-cart-count-value'), 10) || 0);
    }
  }

  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-shade]')) { closeCart(); return; }

    var qtyBtn = e.target.closest('[data-line-key]');
    if (qtyBtn) {
      qtyBtn.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: qtyBtn.getAttribute('data-line-key'), quantity: parseInt(qtyBtn.getAttribute('data-qty'), 10), sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) renderDrawer(data.sections['cart-drawer']); else return refreshDrawer();
          var close = drawer() && drawer().querySelector('[data-drawer-close]');
          if (close) close.focus();
        })
        .catch(function () { qtyBtn.disabled = false; });
      return;
    }

    if (e.target.closest('[data-cookie-settings]')) {
      /* Shopify Cookie Banner (Einstellungen > Kundendatenschutz), Fallback Usercentrics */
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else if (window.__ucCmp && typeof window.__ucCmp.showSecondLayer === 'function') window.__ucCmp.showSecondLayer();
      else if (window.UC_UI && typeof window.UC_UI.showSecondLayer === 'function') window.UC_UI.showSecondLayer();
      else window.location.href = '/pages/datenschutz';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    if (links && links.classList.contains('is-open')) { setNav(false); burger.focus(); }
  });

  /* Fokus in der offenen Seitenleiste halten */
  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key !== 'Tab' || !d || !d.classList.contains('is-open')) return;
    var f = d.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ── In den Warenkorb ───────────────────────────────── */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var msg = form.querySelector('[data-product-msg]');
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt';
      if (msg) msg.textContent = '';

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || 'Das hat leider nicht geklappt.');
          if (res.data.sections) renderDrawer(res.data.sections['cart-drawer']); else return refreshDrawer();
        })
        .then(function () { openCart(); })
        .catch(function (err) { if (msg) msg.textContent = err.message; })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  });

  /* ── Varianten ──────────────────────────────────────── */
  document.querySelectorAll('[data-product]').forEach(function (wrap) {
    var json = wrap.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var selects = wrap.querySelectorAll('[data-option-index]');
    var idInput = wrap.querySelector('input[name="id"]');
    var price = wrap.querySelector('[data-price]');
    var btn = wrap.querySelector('[data-product-form] [type="submit"]');
    var money = function (cents) {
      return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: product.currency || 'EUR' });
    };

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!variant) {
          btn.disabled = true; btn.textContent = 'Nicht verfügbar';
          return;
        }
        idInput.value = variant.id;
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        if (price) {
          price.innerHTML = (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '') + money(variant.price);
        }
        if (variant.featured_media) showMedia(wrap, variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  });

  /* ── Produktgalerie ───────────────────────────────────── */
  function showMedia(wrap, mediaId) {
    var thumb = wrap.querySelector('[data-media-id="' + mediaId + '"]');
    if (thumb) thumb.click();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-media-id]');
    if (!t) return;
    var wrap = t.closest('[data-product]');
    var main = wrap && wrap.querySelector('.sh-pd__main');
    if (!main) return;
    main.src = t.getAttribute('data-src');
    main.srcset = t.getAttribute('data-srcset') || '';
    main.alt = t.getAttribute('data-alt') || '';
    wrap.querySelectorAll('[data-media-id]').forEach(function (b) { b.setAttribute('aria-current', String(b === t)); });
  });

  /* ── Formulare, die sich bei Änderung selbst absenden (Sortierung) ─ */
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });
})();
